// extracted by mini-css-extract-plugin
export default {"component":"Battle_component__5Jxw7","container":"Battle_container__Qp3TE"};